// 系统默认菜单（新增菜单项请同步维护此处）
export const DEFAULT_MENU_LIST = [
  {
    id: 1,
    icon: 'iconfont icon-xiangmushouye1',
    authName: '项目首页',
    path: 'users'
  },
  {
    id: 2,
    icon: 'iconfont icon-caiwuguanli',
    authName: '交款退款',
    path: 'accountMent'
  },
  {
    id: 3,
    icon: 'iconfont icon-caiwubaobiao',
    authName: '账务报表',
    path: 'financialStatements',
    childern: [
      { id: 301, authName: '充值记录', path: 'details' },
      { id: 302, authName: '账单流水', path: 'summary' },
      { id: 303, authName: '售水日报', path: 'sshuiyuebao' },
      { id: 304, authName: '售水月报', path: 'sshuiyuebaos' },
      { id: 305, authName: '售水年报', path: 'ssuinianbao' }
    ]
  },
  {
    id: 4,
    icon: 'iconfont icon-shuibiaoguanli',
    authName: '抄收与设置',
    path: 'Parameter'
  },
  {
    id: 7,
    icon: 'iconfont icon-yongshuifenxi1',
    authName: '用量统计',
    path: 'usageStatistics'
  },
  {
    id: 5,
    icon: 'iconfont icon-jichuziliao',
    authName: '基础资料',
    path: 'basicData',
    childern: [
      { id: 401, authName: '用水类型', path: 'waterType' },
      { id: 402, authName: '位置信息', path: 'positionTion' },
      { id: 403, authName: '表具类型', path: 'Gaugetype' },
      { id: 404, authName: '水表档案', path: 'waterMeterFile' },
      { id: 405, authName: '阀控策略', path: 'strategy' }
    ]
  },
  {
    id: 6,
    icon: 'iconfont icon-xitongguanli',
    authName: '系统管理',
    path: 'systemManagement',
    childern: [
      { id: 601, authName: '账户管理', path: 'userGement' },
      { id: 602, authName: '全局配置', path: 'globalRation' },
      { id: 603, authName: '预警推送', path: 'Alertpush' },
      { id: 604, authName: '菜单配置', path: 'menuConfig' }
    ]
  }
]

/**
 * 将后端已保存的菜单与默认菜单合并：
 * - 保留已保存菜单的顺序与自定义名称
 * - 补全后端旧配置中缺失的一级/二级菜单（如用量统计）
 */
export function mergeMenuConfig (saved) {
  if (!Array.isArray(saved) || !saved.length) {
    return JSON.parse(JSON.stringify(DEFAULT_MENU_LIST))
  }

  const result = JSON.parse(JSON.stringify(saved))
  const savedPaths = new Set(result.map(item => item.path))

  DEFAULT_MENU_LIST.forEach((defaultItem, index) => {
    if (!savedPaths.has(defaultItem.path)) {
      // 按默认顺序插入缺失的一级菜单
      const insertAt = Math.min(index, result.length)
      result.splice(insertAt, 0, JSON.parse(JSON.stringify(defaultItem)))
      return
    }

    // 补全已有一级菜单下缺失的二级菜单
    if (defaultItem.childern && defaultItem.childern.length) {
      const target = result.find(item => item.path === defaultItem.path)
      if (!target) return
      if (!Array.isArray(target.childern)) {
        target.childern = []
      }
      const childPaths = new Set(target.childern.map(c => c.path))
      defaultItem.childern.forEach((child, childIndex) => {
        if (!childPaths.has(child.path)) {
          const insertAt = Math.min(childIndex, target.childern.length)
          target.childern.splice(insertAt, 0, JSON.parse(JSON.stringify(child)))
        }
      })
    }
  })

  return result
}

/**
 * 按 path 查找菜单显示名（支持一级 / 二级）
 * @param {Array} menuList mergeMenuConfig 后的菜单树
 * @param {string} path 菜单 path，可带或不带前导 /
 * @returns {string|null}
 */
export function getMenuAuthName (menuList, path) {
  const p = String(path || '').replace(/^\//, '')
  if (!p || !Array.isArray(menuList)) return null
  for (const item of menuList) {
    if (item.path === p) return item.authName || null
    const children = item.childern || item.children || []
    const child = children.find(c => c.path === p)
    if (child) return child.authName || null
  }
  return null
}

/**
 * 取当前应展示的菜单树（优先 Vuex 已保存配置）
 */
export function resolveMenuList (storeMenu) {
  return mergeMenuConfig(storeMenu && storeMenu.length ? storeMenu : null)
}
